import type { MessagePayloadType } from "@opensea/vessel-0.0"
import { useCallback } from "react"
import type { RPCMessageHandlerFn } from "../RPCMessageHandler.react"

export const useBasicHandler = (): RPCMessageHandlerFn => {
  const handler: RPCMessageHandlerFn = useCallback(
    async (message, reply, wallet) => {
      const ethereumProvider = await wallet.getEthereumProvider()

      try {
        const result = await ethereumProvider.request(message.payload)
        reply(result)
      } catch (error) {
        reply({ error } as MessagePayloadType)
      }
    },
    [],
  )
  return handler
}
